<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyAssetTenantListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyAssetTenantListing from "@/views/pages/admin/propertyAssetTenant/propertyAssetTenantListing";

export default {
    page: {
        title: i18n.t("label.assetRental"),
    },
    components: { Layout, PageHeader, PropertyAssetTenantListing },
    data() {
        return {
            title: i18n.t("label.assetRental"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("label.assetRental"),
                    active: true,
                },
            ],
        };
    },
}
</script>
